
import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import marked from 'marked'
import './Copy.css'

const Copy = props => {
  let text = props.children
  // this is here to support rendering both React components and text
  if (Array.isArray(props.children)) {
    text = props.children.join('')
  }
  const classes = classnames({
    'ui-Copy': true,
    [props.size]: !!props.size,
    [props.align]: !!props.align
  })

  return <div className={classes} dangerouslySetInnerHTML={{ __html: marked(text) }} />
}

Copy.defaultProps = {
  children: ''
}

Copy.propTypes = {
  align: PropTypes.string,
  children: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]).isRequired,
  size: PropTypes.string
}

Copy.displayName = 'Copy'

export default Copy



// WEBPACK FOOTER //
// ./ui/Copy.js